export type Fraction = { n: string; d: string };
const gcd = (a: bigint, b: bigint): bigint => (b ? gcd(b, a % b) : a);
export function fraction(n: bigint, d = 1n): Fraction {
  if (d <= 0n) throw Error("Divisor inválido");
  const g = gcd(n < 0n ? -n : n, d) || 1n;
  return { n: String(n / g), d: String(d / g) };
}
export function amount(value: string, divisor = 1): Fraction {
  if (
    !/^\d{1,12}(\.\d{1,6})?$/.test(value) ||
    !Number.isSafeInteger(divisor) ||
    divisor < 1
  )
    throw Error("Valor inválido");
  const [whole, part = ""] = value.split(".");
  return fraction(
    BigInt(whole + part),
    10n ** BigInt(part.length) * BigInt(divisor),
  );
}
export const add = (a: Fraction, b: Fraction) =>
  fraction(
    BigInt(a.n) * BigInt(b.d) + BigInt(b.n) * BigInt(a.d),
    BigInt(a.d) * BigInt(b.d),
  );
export const compare = (a: Fraction, b: Fraction) => {
  const v = BigInt(a.n) * BigInt(b.d) - BigInt(b.n) * BigInt(a.d);
  return v < 0n ? -1 : v > 0n ? 1 : 0;
};
export const multiply = (a: Fraction, b: Fraction) =>
  fraction(BigInt(a.n) * BigInt(b.n), BigInt(a.d) * BigInt(b.d));
export function displayFraction(a: Fraction, digits = 2): string {
  const signed = BigInt(a.n),
    n = signed < 0n ? -signed : signed,
    d = BigInt(a.d),
    scale = 10n ** BigInt(digits),
    scaled = (n * scale * 2n + d) / (2n * d);
  const text = scaled.toString().padStart(digits + 1, "0");
  const [whole, part] = digits
    ? [text.slice(0, -digits), text.slice(-digits)]
    : [text, ""];
  return (
    (signed < 0n && scaled !== 0n ? "-" : "") +
    new Intl.NumberFormat("pt-BR").format(BigInt(whole)) +
    (digits ? "," + part : "")
  );
}
export type ProgressConfig = {
  version: number;
  enabled: boolean;
  participantIds: string[];
  digits: number;
  ties: "shared";
  levels: Array<{ id: string; name: string; xp: string; color: string }>;
};
export type ProgressRow = {
  id: string;
  name: string;
  points: Fraction;
  xp: Fraction;
  demands: number;
  visits: number | null;
  level: { id: string; name: string; color: string } | null;
  rank: number;
};
export type Profile = {
  userId: string;
  bio: string;
  avatar: string | null;
  version: number;
};
